import { DialogActions as MuiDialogActions } from '@mui/material';

import type { DialogActionsProps } from '@mui/material';
import type { FC } from 'react';

export const DIALOG_ACTIONS_TEST_ID = 'dialog-actions';

export const DialogActions: FC<DialogActionsProps> = props => (
  <MuiDialogActions data-testid={DIALOG_ACTIONS_TEST_ID} {...props} />
);
